import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from '@material-ui/core';

import { MODE } from './const';
import useStyles from './useStyles';

const ConfirmPopup = ({
  className,
  open,
  mode,
  title,
  content,
  confirm,
  cancel,
  onConfirm,
  onCancel,
  classes,
}) => {
  const styles = useStyles({ classes });

  // HINT: we don't use 'onKeyDown' cause it clashes with handler in `Modal`
  const handleKeyUp = useCallback(
    (event) => {
      if (event.key === 'Enter') {
        onConfirm();
      }
    },
    [onConfirm]
  );

  return (
    <Dialog
      classes={{ root: styles.root, paper: cx(styles.paper, className) }}
      open={open}
      onClose={onCancel}
      onKeyUp={handleKeyUp}
      data-mode={mode}
      disableBackdropClick
      data-testid="ConfirmPopup"
    >
      <DialogTitle
        className={styles.dialogTitle}
        disableTypography
      >
        <Typography
          className={styles.title}
          variant="h4"
        >
          {title}
        </Typography>
      </DialogTitle>

      {content && (
        <DialogContent className={styles.dialogContent}>
          <Typography
            className={styles.content}
            variant="body1"
          >
            {content}
          </Typography>
        </DialogContent>
      )}

      <DialogActions className={styles.dialogActions}>
        <Button
          className={styles.buttonCancel}
          onClick={onCancel}
          variant="text"
          color="primary"
          aria-label="Cancel"
          data-testid="ConfirmPopup__CancelButton"
        >
          {cancel || 'No'}
        </Button>
        <Button
          className={styles.buttonConfirm}
          onClick={onConfirm}
          variant="contained"
          color="primary"
          aria-label="Confirm"
          data-testid="ConfirmPopup__ConfirmButton"
        >
          {confirm || 'Yes'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmPopup.propTypes = {
  className: PropTypes.string,
  open: PropTypes.bool.isRequired,
  mode: PropTypes.oneOf(Object.values(MODE)),
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  confirm: PropTypes.string,
  cancel: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  classes: PropTypes.shape({}),
};

ConfirmPopup.defaultProps = {
  className: null,
  mode: MODE.confirmation,
  content: null,
  confirm: null,
  cancel: null,
  classes: null,
};

export default ConfirmPopup;
